import { supabaseClient } from "@/lib/supabase";
import { useAuth } from "@/utils/auth";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "@patient-watch/ui/sonner";
import { getToastCopy } from "@/features/i18n/toastCopy";
import { useNav } from "../../../utils/nav";
import useAuthQuery from "./useAuthQuery";

export async function logout() {
    const { error } = await supabaseClient.auth.signOut();
    if (error) throw error;
}

export const useLogoutMutation = () => {
    const nav = useNav();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { refetch } = useAuthQuery();
    const auth = useAuth();

    return useMutation({
        mutationFn: async () => {
            // Leave the current route before clearing auth so loaders (e.g. /templates/complete)
            // do not flash "not found" while the session is already gone.
            await navigate({ to: "/authenticate", replace: true });
            await logout();
        },
        onError: (error) => {
            toast.error(error.message);
        },
        onSuccess: () => {
            auth.logout();
            nav.reset();
            queryClient.setQueryData(["user"], {});
            toast.success(getToastCopy().loggedOutSuccess);
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: ["user"] });
            refetch();
        },
    });
};
